import { SITE_ID } from 'config';

export const formatKey = (key: string, isRawKey: boolean | undefined) =>
    isRawKey ? key : `maestro__${SITE_ID}__${key}`;

export const LOCAL_STORAGE = 'local';
export const SESSION_STORAGE = 'session';
export type StorageType = typeof LOCAL_STORAGE | typeof SESSION_STORAGE;